import React from "react";
import { Table } from "reactstrap";
import * as moment from "moment";
import { pickupOrderHeaderArray, noRecordStyle } from './Constants'
import { stateConvert } from "web/components/utils/stateAbbreviation";

function TableDataDelOrders(props) {
    const { finalData } = props

    return (
        <>
            <Table responsive>
                <thead>
                    <tr>
                        {pickupOrderHeaderArray.map((items, index) => (
                            <th key={index}>{items.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {finalData?.map((items, index) => (
                        <tr key={index}>
                            <td>{items.orderId}</td>
                            <td>{items?.invoiceNo || 'NA'}</td>
                            <td>{items?.poNumber}</td>
                            <td>{(items.ptplusRefNumber && items?.userType === 'SELLER') ? items.ptplusRefNumber : "NA"}</td>
                            <td>{items?.pickupLocationInfo}</td>
                            <td>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</td>
                            <td>{items?.requestPickupDate}</td>
                            <td>{items.initiatePaymentDate || 'NA'}</td>
                            <td>{items.cardInfo ? `****${items.cardInfo}` : 'NA'}</td>
                            <td>$ {items?.totalAmount?.toFixed(2)}</td>
                        </tr>
                    ))}

                    {finalData?.length === 0 && (<p style={noRecordStyle}>No Records Found</p>)}
                </tbody>
            </Table>
        </>
    )
}

export default TableDataDelOrders;